/**
 * Generate an .ics calendar file and trigger download
 */
export function downloadICS(event) {
  const { title, date, time, venue, address, city } = event;

  // Parse date and time
  const startDate = new Date(date);
  const [startTime] = (time || '14:00').split(' - ');
  const [hours, minutes] = startTime.split(':').map(Number);
  startDate.setHours(hours || 14, minutes || 0, 0);

  const endDate = new Date(startDate);
  endDate.setHours(endDate.getHours() + 8); // Default 8h event

  const formatDate = (d) => {
    return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  };

  const location = [venue, address, city].filter(Boolean).join(', ');

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Invasion Latina//Event//FR',
    'BEGIN:VEVENT',
    `DTSTART:${formatDate(startDate)}`,
    `DTEND:${formatDate(endDate)}`,
    `SUMMARY:${title}`,
    `LOCATION:${location}`,
    `DESCRIPTION:${event.subtitle || 'Invasion Latina'}\\nTickets: ${event.xceed_url || 'https://invasionlatina.be/agenda'}`,
    `URL:${event.xceed_url || 'https://invasionlatina.be/agenda'}`,
    'STATUS:CONFIRMED',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${title.replace(/\s+/g, '-').toLowerCase()}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Generate share links for social media
 */
export function getShareLinks(event) {
  const url = event.xceed_url || 'https://invasionlatina.be/agenda';
  const text = `${event.title} - ${event.date} @ ${event.venue}`;
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);

  return {
    whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
    copy: url
  };
}
